<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <app-card>
    <app-datatable
      ref="datatable"
      :btn-dialog="userHasPermission('store')"
      :form-loading.sync="formLoading"
      :form.sync="dialog"
      :headers="headers"
      :modal-title="datatableDialogTitle"
      :url="tableUrl"
      @submitClickForm="submitClickForm"
    >
      <template #form="props">
        <app-form
          ref="form"
          :errors="formErrors"
          :submit="submitForm"
        >
          <v-container>
            <app-input-avatar
              v-model="selectedItem[getBlobAvatarName]"
              :blob-avatar="blobAvatar"
              :label="isNewItem? 'choose_image' : 'update_image'"
            />
            <v-row>
              <app-text-input
                v-model="selectedItem.name_ar"
                cols="12"
                name="name_ar"
                required
                sm="6"
              />
              <app-text-input
                v-model="selectedItem.name_en"
                cols="12"
                name="name_en"
                required
                sm="6"
              />
              <app-text-input
                v-model="selectedItem.url"
                clearable
                cols="12"
                name="url"
                sm="6"
              />
              <app-text-input
                v-model="selectedItem.stand"
                clearable
                cols="12"
                name="stand"
                sm="6"
              />
              <app-number-input
                v-model="selectedItem.order_by"
                cols="12"
                name="order_by"
                sm="6"
              />
              <app-users
                v-if="!selectedItem.new_user"
                v-model="selectedItem.user_id"
                cols="12"
                name="user_id"
                clearable
                sm="6"
              />
            </v-row>
            <!--<v-fade-transition
              hide-on-leave
              leave-absolute
            >
              <account-form
                v-if="selectedItem.new_user"
                v-model="selectedItem"
              >
                <template #after>
                  <v-col cols="12">
                    <password-form
                      v-model="selectedItem"
                      nullable-password
                    />
                  </v-col>
                </template>
              </account-form>
            </v-fade-transition>-->
            <v-row align="center">
              <app-switcher
                v-if="isNewItem"
                v-model="selectedItem.new_user"
                cols="auto"
                name="new_user"
              />
              <app-switcher
                v-model="selectedItem.active"
                cols="auto"
                name="active"
              />
            </v-row>
          </v-container>
        </app-form>
      </template>

      <template #item.control="{item}">
        <app-dt-btn
          v-if="userHasPermission('update')"
          :disabled="loadingDatatable"
          update
          @click="showUpdateDialog(item)"
        />
        <app-dt-btn
          v-if="userHasPermission('destroy')"
          :disabled="loadingDatatable"
          destroy
          @click="deleteItem(item)"
        />
      </template>

      <template #item.avatar="{item}">
        <app-dt-avatar
          v-if="item.avatar"
          :src="item.avatar"
        />
      </template>
      <template #item.url="{item}">
        <app-btn
          v-if="item.url"
          text
          target="_blank"
          :href="item.url"
        >
          {{ $t('view') }}
        </app-btn>
      </template>
    </app-datatable>
  </app-card>
</template>
<script>
import { DatatableMixin, MetaInfoMixin, AvatarInputMixin } from '@mixins'
import AccountForm from '@components/user/AccountForm'
import PasswordForm from '@components/user/PasswordForm'

export default {
  name: 'Companies',
  components: { PasswordForm, AccountForm },
  helperApiName: 'company',
  mixins: [MetaInfoMixin, DatatableMixin, AvatarInputMixin],
  data () {
    return {
      modelPermission: 'Utilities.Company',
      headers: [
        {
          text: 'avatar',
          value: 'avatar',
          width: 100
        },
        'name',
        'url',
        'stand',
        'user_id_to_string',
        {
          text: 'status',
          value: 'active_to_string'
        },
        'order_by',
        'control'
      ]
    }
  },
  computed: {
    defaultSelectedItem () {
      return {
        order_by: 0,
        other: !1,
        active: !0
      }
    }
  },
  mounted () {
    this.checkPermission('index')
  }
}
</script>
